<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn class="add-course-button" outlined dark v-on="on">
        Import Users
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in importUserOptions"
        :key="index"
        @click="showPanel(index)"
      >
        <v-list-item-title class="text-left">{{
          item.title
        }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import ImportCSV from '@/components/admin/users/Import';
export default {
  data() {
    return {
      importUserOptions: [{ title: 'CSV' }],
    };
  },
  methods: {
    showPanel(id) {
      switch (id) {
        case 0:
          this.showCSVImportPanel();
          break;
      }
    },
    showCSVImportPanel() {
      this.$showPanel({
        component: ImportCSV,
        openOn: 'right',
      });
    },
  },
};
</script>
